import React from "react";
import {
  Modal,
  Button,
  Row,
  Col,
  Typography,
  Form,
  Checkbox,
  message,
} from "antd";
import InputBox from "../../../components/common/input";
import { useDispatch } from "react-redux";
import { changePassword } from "../../../redux/action/auth/authAction";
import { useNavigate } from "react-router";

const { Title, Text } = Typography;

const ChangePasswordModal = ({ open, onClose }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();

    const handleSubmit = (values) => {

      form.resetFields();
      try {
        dispatch(
          changePassword(values, () => {
            form.resetFields();
            onClose();
            navigate("/dashboard");
          })
        );
      } catch (error) {
        message.error("OTP verification failed. Please try again.");
      }
    };

  return (
    <Modal
      centered
      open={open}
      onCancel={onClose}
      footer={null}
      className="custom-confirm-modal"
    >
      <div className="changePassword">
        <Row gutter={16} className="signin-row">
          <Col xs={24} sm={24}>
            <div className="cflex">
              <div className="leftContainer">
                <Title level={2}>Change Password</Title>
                <Text className="subtitle mb-2">
                  Almost done. Enter your new password and you’re all set.
                </Text>
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={handleSubmit}
                  className="signin-form"
                >
                  <Form.Item
                    name="currentPassword"
                    label="Current Password"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your current password!",
                      },
                      {
                        pattern:
                          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                        message:
                          "Password must be at least 8 characters, include one uppercase, one lowercase, one number, and one special character.",
                      },
                    ]}
                  >
                    <InputBox
                      size="large"
                      placeholder="Current Password"
                      // className="custom-input"
                      type="password"
                    />
                  </Form.Item>

                  <Form.Item
                    name="newPassword"
                    label="New Password"
                    rules={[
                      {
                        required: true,
                        message: "Please enter a new password!",
                      },
                      {
                        pattern:
                          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                        message:
                          "Password must be at least 8 characters, include one uppercase, one lowercase, one number, and one special character.",
                      },
                    ]}
                  >
                    <InputBox
                      size="large"
                      placeholder="New Password"
                      // className="custom-input"
                      type="password"
                    />
                  </Form.Item>

                  <Form.Item
                    name="confirmPassword"
                    label="Confirm New Password"
                    dependencies={["newPassword"]}
                    rules={[
                      {
                        required: true,
                        message: "Please confirm your password!",
                      },
                      {
                        pattern:
                          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                        message:
                          "Password must be at least 8 characters, include one uppercase, one lowercase, one number, and one special character.",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (
                            !value ||
                            getFieldValue("newPassword") === value
                          ) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error("Passwords do not match!")
                          );
                        },
                      }),
                    ]}
                  >
                    <InputBox
                      size="large"
                      placeholder="Confirm New Password"
                      // className="custom-input"
                      type="password"
                    />
                  </Form.Item>

                  {/* <Form.Item
                    name="terms"
                    valuePropName="checked"
                    rules={[
                      {
                        required: true,
                        message: "You must accept the terms and conditions!",
                      },
                    ]}
                  >
                    <Checkbox>I accept the Terms and Conditions</Checkbox>
                  </Form.Item> */}

                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="confirm-btn"
                      block
                    >
                      Change Password
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export default ChangePasswordModal;
